import LovrFire from '../lovrfire'
import firebase from 'firebase';
import {
    v4 as uuidv4
} from 'uuid';

import imageCompression from 'browser-image-compression';

export const loadRecentChats = async (userID, observer) => {
    LovrFire.firestore().collection('chats')
        .orderBy(`participants.${userID}`)
        .onSnapshot(observer)
}

export const onlineStatus = async (userID, observer) => {
    console.log(userID, " UID   ")
    const ref = LovrFire.database().ref('/status/' + userID)
    ref.on('value', observer)
}

export const searchMessage = async (string, userID) => {
    var matched = []
    if(string.trim() == "")
        return null
    const res = await LovrFire.firestore().collection('chats')
    .orderBy(`participants.${userID}`).get()
    for(var i = 0; i < res.docs.length; i++){
        const subRes = await LovrFire.firestore()
        .collection('chats').doc(res.docs[i].id)
        .collection('messages').orderBy('timestamp').get();

        for(var j = 0; j < subRes.docs.length; j++){
            if( subRes.docs[j].data().text.toLowerCase().includes(string.toLowerCase())){
                const user = await LovrFire.firestore().collection('users').doc(subRes.docs[j].data().uid).get()
                const remoteUser = await LovrFire.firestore().collection('users').doc(Object.keys(res.docs[i].data().participants).filter(uid => uid!= userID)[0]).get()
                matched.push({
                    id: res.docs[i].id,
                    read: res.docs[i].data().read,
                    notification: res.docs[i].data().notification,
                    msg: subRes.docs[j].data(),
                    user: user.data(),
                    remoteUser: remoteUser.data(),
                    document: res.docs[i].data()
                })
            }
        }
    }

    return matched

}

export const fetchChatUser = async (userID) => {
    const res = LovrFire.firestore().collection('users').doc(userID);
    const userData = await res.get();
    return userData.data()
}

export const loadMessages = async (data, observer) => {
    return LovrFire.firestore().collection('chats').doc(data.id).collection('messages').orderBy('timestamp').onSnapshot(observer)
}

export const sendMessage = async (docId, message, user, remoteUser) => {
    const msgDoc = LovrFire.firestore().collection('chats').doc(docId).collection('messages').doc().id
    const time = firebase.firestore.FieldValue.serverTimestamp()
   
    await LovrFire.firestore().collection('chats').doc(docId).collection('messages').doc(msgDoc).set({
        text: message,
        uid: user,
        timestamp: time,
        id: msgDoc
    })

    await LovrFire.firestore().collection('chats').doc(docId).update({
        timestamp: time,
        last_message: message,
        [`read.${user}`]: true,
        [`read.${remoteUser}`]: false
    })
}

export const sendMediaMessage = async (docId, media, user, type, price, monetization, remoteUser) => {
    const msgId = LovrFire.firestore().collection('chats').doc(docId).collection('messages').doc().id;
    const mediaStorageRef = LovrFire.storage().ref(`/chats/${docId}/${msgId}`);
    const mediaStorageRef64 = LovrFire.storage().ref(`/chats/${docId}/${msgId}_64x64`);
    const time = firebase.firestore.FieldValue.serverTimestamp()

    var downloadURL = ''
    var thumbURL = ''

    const resMedia = await fetch(media);
    const blob = await resMedia.blob();

    if (type.includes('image')) {
        const compressionOptions = {
            maxSizeMB: .5,
            maxWidthOrHeight: 512,
            useWebWorker: true
        }

        const thumbCompressionOptions = {
            maxSizeMB: .00001,
            maxWidthOrHeight: 64,
            useWebWorker: true
        }

        const compressedFile = await imageCompression(blob, compressionOptions);
        const compressedFile64 = await imageCompression(blob, thumbCompressionOptions);

        await mediaStorageRef.put(compressedFile);
        await mediaStorageRef64.put(compressedFile64)


        downloadURL = await mediaStorageRef.getDownloadURL()
        thumbURL = await mediaStorageRef64.getDownloadURL()

    } else {
        await mediaStorageRef.put(blob);
        downloadURL = await mediaStorageRef.getDownloadURL()
        thumbURL = ''
    }


    
    await LovrFire.firestore().collection('chats').doc(docId).collection('messages').doc(msgId).set({
        text: 'Sent Media',
        uid: user,
        timestamp: time,
        thumbnail: thumbURL,
        id: msgId,
        media: downloadURL,
        type: type,
        paid: false,
        price: price || 0,
        isPaid: monetization
    })

    await LovrFire.firestore().collection('chats').doc(docId).update({
        timestamp: time,
        last_message: 'Sent Media',
        [`read.${user}`]: true,
        [`read.${remoteUser}`]: false
    })
}

export const markRead = async(channel, id) => {
    await LovrFire.firestore().collection('chats').doc(channel).update({
        [`read.${id}`]: true
    })
}

export const deleteChat = async(channel) => {
    return await LovrFire.firestore().collection('chats').doc(channel).delete()
}

export const toggleNotification = async (user, channel, val) => {
    await LovrFire.firestore().collection('chats').doc(channel).update({
        [`notification.${user}`] : val
    })
}

export const refreshChannel = async (channel) => {
    const res = await LovrFire.firestore().collection('chats').doc(channel).get()
    return res.data()
}

export const initMessage = async (user, remoteUser) => {
    const res = await LovrFire.firestore().collection('chats').orderBy(`participants.${user}`).get()

    for (var i = 0; i < res.docs.length; i++) {
        if (Object.keys(res.docs[i].data().participants).includes(remoteUser)) {
            const prevMsg = await LovrFire.firestore().collection('chats').doc(res.docs[i].id).collection('messages').get()
            if(prevMsg.docs.length > 0)
                return res.docs[i].id
            else if(prevMsg.docs.length == 0) {
                await LovrFire.firestore().collection('chats').doc(res.docs[i].id).delete()
            }
        }
    }

    const docID = LovrFire.firestore().collection('chats').doc()
    await LovrFire.firestore().collection('chats').doc(docID.id).set({
        last_message: ' ',
        participants: {
            [`${user}`]: user,
            [`${remoteUser}`]: remoteUser
        },
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        notification: {
            [`${user}`]: true,
            [`${remoteUser}`]: true
        },
        read: {
            [`${user}`]: true,
            [`${remoteUser}`]: true
        }
    })
    return docID.id;
}